import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import de from 'date-fns/locale/de';
import { translate } from "react-i18next";
import '../../css/style.css';
import '../Home.css';
import { Form, Row, Col, Button, OverlayTrigger, Tooltip, Card } from 'react-bootstrap';
import FileUpload from '../util/FileUpload';
import { ACT_CATEGORIES } from '../../backend/Data';
import i18n from "i18next";
import { getTransValue } from "../../backend/UIUtils";
import {  sendJson, getURL, BACKEND_URL, EVENT_IMG_URL } from '../../backend/Backend';
import {getCountries , getCountriesMap} from '../../backend/Countries';
import axios from 'axios';


registerLocale('de', de)


class EventEditDetail extends Component {

    constructor(props) {
        super(props);

        this.onEventAdd = this.onEventAdd.bind(this);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.removeImage = this.removeImage.bind(this);
        this.executeFileUpload = this.executeFileUpload.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
       
        //this.updateEventStatus = this.updateEventStatus.bind(this);

        this.state = {
            validated: false,
            event: this.props.detailModel,
            selectedCat: null
        };
    }

  
    componentWillReceiveProps(nextProps) {
        let selectedCat = null;
        let oldState = this.state;
        if (this.props.detailModel.eventCategory) {
            if ("0" === this.state.event.eventCategory) {
                selectedCat = null;
            } else {
                let filteredcat = ACT_CATEGORIES.filter(cat => cat.code === this.state.event.eventCategory);
                if (filteredcat && filteredcat.length > 0) {
                    selectedCat = filteredcat[0];
                }
                this.setState({
                    ...oldState,
                    selectedCat: selectedCat
                });
            }
        }
    }


    onEventAdd() {
        sendJson('post', 'events/save', this.state.event).then(
            received => {
                console.log("Saved Event: " + received.id + " start:" + received.startDate);
            });
    }


  
    removeImage(imageName){
        console.log("removeImage: "+ imageName);
        let path = 'storage/deleteFile/' + imageName+ "/" + this.state.event.eventId+"/1";
        

        fetch(getURL(path))
        .then((response) => {
          //this.props.removeComment(id);
          let oldState = this.state;
          let oldEvent = this.state.event;
          oldEvent.imageName = null;
          this.setState({
            ...oldState,
            event: oldEvent
        });
        })
        .catch((error) => {
          console.error(error);
        });
    
    }

    executeFileUpload(file, id) {
        if(!file){
          return;
        }
    
      
         console.log("executeFileUpload: "+file.name +" id:"+id);
         this.fileUpload(file, id, 1);
         let oldState = this.state;
         this.setState({
           ...oldState,
           message: 'fileUploaded'
         });
         setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
      }

      fileUpload(file, id, eventType) {
        if(!file){
          return;
        }
      
        let path = 'storage/uploadFile/' + id +"/"+eventType;
        const url = `${BACKEND_URL}${path}`;
      
        const formData = new FormData();
        formData.append('file', file);
        formData.append('name', file.name);
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
         axios.post(url, formData, config)
         .then((fileName) => {
            if(fileName && fileName.data){
                let oldState = this.state;
                let oldEvent = this.state.event;
                oldEvent.imageName = fileName.data;
                this.setState({
                  ...oldState,
                  event: oldEvent
              });
            }
          
          })
          .catch((error) => {
            console.error(error);
          });
      }

      onFileChange(file) {
        this.executeFileUpload(file, this.state.event.eventId);
    }




    handleChange(e) {

        const { event } = this.state;

        const newEvent = {
            ...event,
            [e.target.name]: e.target.checked
        };

        console.log("event limit changed:" + JSON.stringify(newEvent));

        this.setState({
            event: newEvent
        });
    }

    onEventInputChange(e) {
        const { name: fieldName, value: fieldValue } = e.target;

        console.log("land :"+e.target.value);

        const { event } = this.state;
        let oldState = this.state;


        let selectedCat = this.state.selectedCat;
        if (e.target.name === 'eventCategory') {
            if ("0" === e.target.value) {
                selectedCat = null;
            } else {
                let filteredcat = ACT_CATEGORIES.filter(cat => cat.code === e.target.value);
                if (filteredcat && filteredcat.length > 0) {
                    selectedCat = filteredcat[0];
                }
            }
        }

        const newEvent = {
            ...event,
            eventCategory: selectedCat ? selectedCat.code : null,
            [fieldName]: fieldValue
        };

      
        this.setState({
            ...oldState,
            event: newEvent,
            selectedCat: selectedCat
        });

    }

   
    render() {
        const { t } = this.props;
        let lang = i18n.language;
        let countries = getCountries(lang);
        const { event: { title, eventType, eventCategory, subCategory, description, commentsEnabled, maxParticipants, eventLink, imageName , locationName, street, zipcode, city, country} } = this.state;

        return (
            <div>
                <form className=" ml-2 mr-2 mb-2">
                    <Row className="pt-3 " >
                        <Col lg={2} md={4}>
                            <Form.Check type={"radio"} id={`check-api-1`} className="primary">
                                <Form.Check.Input type={"radio"} name="eventType" value="PRIVATE" checked={eventType === 'PRIVATE'} onChange={this.onEventInputChange} />
                                <Form.Check.Label  >
                                    <OverlayTrigger
                                        placement="bottom" className="success"
                                        overlay={<Tooltip id="button-tooltip-2">{t("privateActivityInfo1") }</Tooltip>}>
                                        <i class="fas fa-lock mr-1 ml-1"></i>
                                    </OverlayTrigger>
                                    {t("private")}</Form.Check.Label>
                            </Form.Check>
                        </Col>
                        <Col lg={4} md={4}>
                            <Form.Check type={"radio"} id={`check-api-1`} className="primary">
                                <Form.Check.Input type={"radio"} name="eventType" value="ACTIVITY" checked={eventType === 'ACTIVITY'} onChange={this.onEventInputChange} />
                                <Form.Check.Label  >
                                <OverlayTrigger
                                        placement="bottom" className="success"
                                        overlay={<Tooltip id="button-tooltip-2">{t("publicActivityInfo1")}</Tooltip>}>
                                            <i class="fas fa-globe-europe mr-1 ml-1"></i>
                                            </OverlayTrigger>
                                {t("public")}</Form.Check.Label>
                            </Form.Check>
                        </Col>

                    </Row>
                    {eventType === 'ACTIVITY' ?
                        <div>
                            
                            <Row className="mt-3">
                                <Col lg={5} md={12}>
                                    <Form.Control as="select" name="eventCategory" value={eventCategory} onChange={this.onEventInputChange} defaultValue="0">
                                        <option value="0">{t("catChoose")}</option>
                                        {ACT_CATEGORIES.map(c =>
                                            <option value={c.code} key={c.code} label={getTransValue(c, lang)}></option>
                                        )}
                                    </Form.Control>
                                </Col>
                                <Col lg={5} md={12} >
                                    <Form.Control as="select" name="subCategory" value={subCategory} onChange={this.onEventInputChange}
                                        disabled={!this.state.selectedCat && !subCategory} >
                                        {!this.state.selectedCat ?
                                            <option value="0">{t("subCatChoose")}</option>
                                            :
                                            ''
                                        }

                                        {this.state.selectedCat ?
                                            this.state.selectedCat.subs.map(c =>
                                                <option value={c.code} key={c.code} label={getTransValue(c, lang)}></option>
                                            )
                                            : ''
                                        }
                                    </Form.Control>
                                </Col>
                            </Row>
                        </div>
                        :
                      ''
                    }

                    <Row className="pt-3 " >
                        <Col lg={10} md={8}>
                            <Form.Control value={title}
                                name="title"
                                onChange={this.onEventInputChange}
                                placeholder={t("eventTitle")}
                                maxLength={250}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={10} md={8}>
                            <Form.Control as="textarea" value={description}
                                name="description" onChange={this.onEventInputChange}
                                placeholder={t("eventDescription")} className="mt-2 "
                                rows="5" 
                                maxLength={2000}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={10} md={8}>
                            <Form.Control placeholder={t("externLink")}
                                value={eventLink} name="eventLink"
                                onChange={this.onEventInputChange} className="mt-2" 
                                maxLength={250} />
                        </Col>
                    </Row>
                    {eventType === 'ACTIVITY' ?
                        <Row className="pt-2 pb-2">
                            <Col lg={12} md={12} >
                            <Row className="mt-1 mb-1">
                            <Col lg={1} >
                                    <Form.Label>{t("bild")}</Form.Label>
                            </Col>
                            {!imageName ? 
                            <Col lg={4} >
                                <FileUpload fileChanged={ this.onFileChange} />
                            </Col>
                            :
                            ''}
                            {imageName ? 
                            <Col lg={5} >
                                 <Card.Img variant="top" src={ EVENT_IMG_URL + imageName } style={{"width":"6rem"}} className="float-left"/>
                                 <Button variant="outline-primary" onClick={() => this.removeImage(imageName)} className="float-left ml-3 mt-2"><span className="fa fa-trash-alt ">&nbsp;{t("removeImage")}</span></Button>
 
                                </Col>
                                :
                                ''}
                           
                        </Row>
                            </Col>
                        </Row>
                        : ''
                    }

                    <Row className="mt-3">
                        <Col lg={10} md={8}>
                            <Form inline>
                                <Form.Group controlId="limitParticipants" >
                                    <Form.Label>{t("limitParticipants")}</Form.Label>
                                    <Form.Control value={maxParticipants} name="maxParticipants"
                                        onChange={this.onEventInputChange}
                                        placeholder={t("maxParticipants")} style={{ with: "80px" }} className="ml-2" />
                                </Form.Group>
                            </Form>
                        </Col>
                        <Col lg={10} md={8}>
                            <Form.Check label={t("KommentarenAktivieren")} name="commentsEnabled" id="commentsEnabled" checked={commentsEnabled} onChange={this.handleChange} />
                        </Col>

                    </Row>
                     
                    <Row>	
                        <Col lg={10} md={8}>	
                            <Form.Control placeholder={t("local")} className="mt-2"	
                                value={locationName} name="locationName"	
                                onChange={this.onEventInputChange}	
                                maxLength={150}
                            />	
                        </Col>
                        </Row>
                        <Row>	
                        <Col lg={10} md={8}>	
                            <Form.Control placeholder={t("strasse")}	
                            value={street} name="street" 	
                            onChange={this.onEventInputChange} className="mt-2"  maxLength={250}/>	
                        </Col>	
                        </Row>
                        <Row>	
                        <Col lg={2} md={4}>	
                            <Form.Control placeholder={t("plz")} className="mt-2" 	
                            value={zipcode} name="zipcode"	
                            onChange={this.onEventInputChange}  maxLength={10}/>	
                        </Col>	
                        <Col lg={4} md={4} >	
                            <Form.Control placeholder={t("ort")} className="mt-2" 	
                            value={city} name="city"	
                            onChange={this.onEventInputChange}  maxLength={50} />	
                        </Col>	
                        <Col lg={4} md={4} className="mt-2">
                            <Form.Control as="select" name="country" value={country} onChange={this.onEventInputChange} >
                            {[...getCountriesMap(lang).keys()].map((k, i) =>
                               <option key={k} value={k}>{countries[k]}</option>
                            )
                        }
                        </Form.Control>
                        </Col>

                    </Row>

                    <Row className="pb-3">
                        <Col lg={10} md={8}>
                            {(this.props.editMode) ?
                                (
                                    <OverlayTrigger
                                        key="top"
                                        placement="top"
                                        overlay={
                                            <Tooltip id={`tooltip-top`}>
                                                {t("speichern")}
                                            </Tooltip>
                                        }>
                                        <Button variant="outline-primary" onClick={() => this.props.saveEvent(this.state.event)} className="float-left mt-3" disabled={this.props.deleted}><span className="fa fa-save ">&nbsp;{t("speichern")}</span></Button>
                                    </OverlayTrigger>
                                )

                                :
                                ''
                            }
                        </Col>
                    </Row>
                </form>
            </div>
        )
    }
}

export default translate("translations")(EventEditDetail);
